// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__1YlF6","badge":"styles_badge__hYRzC"};